import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import { FaUserCircle } from 'react-icons/fa'

const MemberInformation = ({ fullName }) => {
  return (
    <Content>
      <Col xs={3}>
        <LogoMin />
      </Col>
      <Col xs={8}>
        <MemberTitle>{`${fullName}`}</MemberTitle>
        <MemberP>
          NSPA Member
        </MemberP>
      </Col>
    </Content>
  )
}

const Content = styled(Row)`
  margin: 0.5rem 0;
`

const LogoMin = styled(FaUserCircle)`
  font-size: 5rem;
  padding-top: 0.5rem;
  color: ${({ theme }) => theme.palette.primary[5]};

`

const MemberTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
  margin-top: 0.5rem;
`

const MemberP = styled.div`
  font-size: 0.9rem;  
  font-weight: 300;
`

export default MemberInformation
